// Kall til klubbportalen (src/routes/klubbportal.js). Alle kall sender den valgte ansatte i
// X-Ansatt: skriving sjekker leder/klubbansvarlig og fører navnet på endringen, og lesing tar med
// innlegg som bare er for ledere når den ansatte er leder eller klubbansvarlig.
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const BUTIKKER = [
  { verdi: 'ROYKEN', tittel: 'Sport 1 Røyken' },
  { verdi: 'SLEMMESTAD', tittel: 'Sport 1 Slemmestad' },
];
export const butikkNavn = (b) => BUTIKKER.find((x) => x.verdi === b)?.tittel || b;
// butikkid-cookien: 1 = Røyken, 2 = Slemmestad.
export const valgtButikk = () => (Cookies.get('butikkid') === '2' ? 'SLEMMESTAD' : 'ROYKEN');

export const ROLLER = [
  { verdi: 'trener', tittel: 'Trener', flertall: 'Trenere' },
  { verdi: 'innkjopsansvarlig', tittel: 'Innkjøpsansvarlig', flertall: 'Innkjøpsansvarlige' },
  { verdi: 'kontakt', tittel: 'Annen kontakt', flertall: 'Andre kontakter' },
];
export const rolleNavn = (r) => ROLLER.find((x) => x.verdi === r)?.tittel || r;

export const sarIdrettNavn = (klubb, id) =>
  id ? klubb?.sarIdretter?.find((s) => s._id === id)?.navn || '' : '';

export async function klubbApi(sti, { method = 'GET', body } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  headers['X-Ansatt'] = encodeURIComponent(Cookies.get('selectedEmployee') || '');
  const r = await fetch(`${API_BASE_URL}/klubbportal${sti}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || 'Noe gikk galt. Prøv igjen.');
  return data;
}

export const formatDato = (d) =>
  d ? new Date(d).toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
